import React from 'react';

interface Props {
  title: string;
  subtitle?: string;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** Card-shaped section wrapper with header. Used by every tab. Tokens come
 * from `.stagery-admin-scope` in AdminConsole.tsx (var(--surface), --line, etc.) */
export const Section: React.FC<Props> = ({ title, subtitle, toolbar, children, className = '' }) => (
  <div
    className={`overflow-hidden ${className}`}
    style={{
      background: 'var(--surface)',
      border: '1px solid var(--line)',
      borderRadius: 'var(--radius-xl)',
      boxShadow: 'var(--shadow)',
    }}
  >
    <div
      className="px-5 md:px-6 py-4 flex items-start justify-between gap-4 flex-wrap"
      style={{ borderBottom: '1px solid var(--line)' }}
    >
      <div className="min-w-0">
        <h2 className="font-semibold tracking-[-0.015em]" style={{ color: 'var(--ink)', fontSize: '15px' }}>{title}</h2>
        {subtitle && <p className="mt-1" style={{ color: 'var(--ink-55)', fontSize: '12.5px' }}>{subtitle}</p>}
      </div>
      {toolbar}
    </div>
    {children}
  </div>
);
